import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ConfigService } from '../../../core/auth/services/config.service';
import { Observable } from 'rxjs';
import { PreAssessmentApiResponse, QuestionAnswerApiResponse } from '../appointment-const/appointmentHistory-model';

@Injectable({
  providedIn: 'root'
})
export class AssessmentHistoryService {

      private httpClient = inject(HttpClient);
    private configService = inject(ConfigService);
    private baseUrl = this.configService.getPatientAPIUrl();
    private apiUrl = this.configService.getAPIUrl(); // v2


  constructor() { }



  getAssessmentHistory(id: string, paging:any) :Observable<PreAssessmentApiResponse> {

    return this.httpClient.get<PreAssessmentApiResponse>(`${this.apiUrl}/api/PreAssessment/${id}`, { params: paging }); // Assuming endpoint

  }

  getAssessmentDetails(assessmentId: string): Observable<QuestionAnswerApiResponse> {
    return this.httpClient.get<QuestionAnswerApiResponse>(`${this.apiUrl}/api/PreAssessmentAnswers/${assessmentId}`); // Assuming endpoint
  }
}
